import React, {createContext, useEffect, useReducer, useState} from 'react';
import firebase from 'src/lib/firebase';
import {
  applyActionCode,
  confirmPasswordReset,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  verifyPasswordResetCode
} from "firebase/auth";
import {collection, getFirestore} from "firebase/firestore";
import {Navigate} from "react-router";
import {executeMutationUtil, executeQueryUtil} from "../utils/gqlUtil";
import {getProductUserQuery, updateProductUserMutation} from "../gql/productUserGql";
import {getBrandQuery} from "../gql/BrandGql";
import {SplashScreen} from "../components/splash-screen";
import moment from "moment";
import {getSuperUserWhiteListQuery} from "../gql/superUserWhiteList";
import {getBrandAdminQuery} from "../gql/BrandAdminGql";
import {bulkDeleteTempBrandUserMutation, getTempBrandUserByEmailQuery} from "../gql/tempBrandUserGql";
import cloneDeep from "clone-deep";
import {authChangeRoute, emailVerificationRoute, loginRoute, registerRoute, resetPasswordRoute} from "../routes";
import {FileUploader} from "../sections/dashboard/file-manager/file-uploader";
import {useNavigate} from "react-router-dom";
import {useWindowSize} from "@react-hook/window-size";
import Confetti from "react-confetti";
import {getAllEstablishmentsQuery} from "../gql/establishmentGql";
import {filterWeek, filterSingleDay, filterMonth, filterYear} from "../pages/Home/FilterInfoOverview";
import {getOrdersByDayQuery, getOrdersByRangeQuery} from "../gql/OrderGql";
import {getFilterDateString} from "../utils/FilterHelper";
import {getSumUpDayQuery} from "../gql/SumUpDayGql";
import {mergeSumUpDayData} from "../utils/SumupDayUtil";
import {getProductsQuery} from "../gql/ProductGql";
import {getCategoriesQuery} from "../gql/CategoryGql";
import {getStaffsQuery} from "../gql/StaffGql";
import {getPaymentModesQuery} from "../gql/PaymentModesGql";
import {getLocationsQuery} from "../gql/LocationGql";
import {getRhDatasByDayQuery, getRhDatasByRangeQuery} from "../gql/RhDataGql";
import {getWeatherByDayQuery} from "../gql/WeatherDataGql";
import dayjs from "dayjs";
import {getOptionListsQuery} from "../gql/OptionListsGql";
import {customChartRoute} from "../routes/dashboard";
import {fillDataNames} from "../utils/graphUtil";
import {getSumUpWeekQuery} from "../gql/SumUpWeekGql";
import {decompressFromBase64} from "../utils/compressUtil";
import {getSumUpMonthQuery} from "../gql/SumUpMonthGql";
import {getDaysQuery} from "../gql/DayGql";

const db = getFirestore();

const initialAuthState = {
  isAuthenticated: false,
  isInitialized: false,
  isSkipPhoneVerification: false,
  userGetAtLeastOnEstablishment: false,
  user: null,
  userInDb: null,
  brand : null,
  establishment : null,
  superAdmin: false,
  emailVerified: false,
  displayNavBar: true,
  displaySettingButton: true,
  processUserInDb: false,
  logging: false,
  uploadFileOpen: false,
  fileUploaded: false,
  orders: [],
  staffWorks: [],
  weatherSingleDay: {},
  weatherDays: [],
  sumUpDays: [],
  singleSumUpDays: [],
  products: [],
  optionLists: [],
  categories: [],
  staffs: [],
  paymentModes: [],
  locations: [],
  establishments: [],
  mergedSumUpDay: null,
  mergedSumUpDayWithNames: null,
  filter: {
    filterType: filterSingleDay,
    // singleDay: dayjs(moment().format())
  },
  loading: false,
  reloadCustomBoardList: false,
  navbarMobileReload: false,
};

const PROCESS_USER_IN_DB = 'PROCESS_USER_IN_DB';
const DISPLAY_SETTING_BUTTON = 'DISPLAY_SETTING_BUTTON';
const DISPLAY_NAV_BAR = 'DISPLAY_NAV_BAR';
const UPDATE_DB_PROFILE = 'UPDATE_DB_PROFILE';
const AUTHENTICATE_TO_APP = 'AUTHENTICATE_TO_APP';
const INITIALIZED = 'INITIALIZED';
const AUTHENTICATED = 'AUTHENTICATED';
const E_MAIL_VERIFIED = 'E_MAIL_VERIFIED';
const BRAND = 'BRAND';
const ESTABLISHMENT = 'ESTABLISHMENT';
const FILTER = 'FILTER';
const ORDERS = 'ORDERS';
const STAFF_WORKS = 'STAFF_WORKS';
const WEATHER_SINGLE_DAY = 'WEATHER_SINGLE_DAY';
const WEATHER_DAYS = 'WEATHER_DAYS';
const SUMUPDAYS = 'SUMUPDAYS';
const SINGLESUMUPDAYS = 'SINGLESUMUPDAYS';
const MERGEDSUMUPDAY = 'MERGEDSUMUPDAY';
const MERGEDSUMUPDAYWITHNAMES = 'MERGEDSUMUPDAYWITHNAMES';
const SUPER_ADMIN = 'SUPER_ADMIN';
const LOGGING = 'LOGGING';
const UPLOAD_FILE_OPEN = 'UPLOAD_FILE_OPEN';
const FILE_UPLOADED = 'FILE_UPLOADED';
const LOADING = 'LOADING';
const PRODUCTS = 'PRODUCTS';
const OPTIONS_LIST = 'OPTIONS_LIST';
const CATEGORIES = 'CATEGORIES';
const STAFFS = 'STAFFS';
const PAYMENTMODES = 'PAYMENTMODES';
const LOCATIONS = 'LOCATIONS';
const ESTABLISHMENTS = 'ESTABLISHMENTS';
const RELOAD_CUSTOM_BOARD_LIST = 'RELOAD_CUSTOM_BOARD_LIST';
const NAV_BAR_MOBILE_RELOAD = 'NAV_BAR_MOBILE_RELOAD';


const reducer = (state, action) => {
  switch (action.type) {

    case NAV_BAR_MOBILE_RELOAD: {
        const { navbarMobileReload } = action.payload;
        return {
            ...state,
            navbarMobileReload: navbarMobileReload,
        }
    }

    case RELOAD_CUSTOM_BOARD_LIST: {
        const { reloadCustomBoardList } = action.payload;
        return {
            ...state,
            reloadCustomBoardList: reloadCustomBoardList,
        }
    }

    case LOADING: {
      const { loading } = action.payload;
      return {
        ...state,
        loading: loading,
      };
    }



    case UPLOAD_FILE_OPEN: {
      const { uploadFileOpen } = action.payload;
      return {
        ...state,
        uploadFileOpen: uploadFileOpen,
      };
    }

    case FILE_UPLOADED: {
      const { fileUploaded } = action.payload;
      return {
        ...state,
        fileUploaded: fileUploaded,
      };
    }

    case LOGGING: {
      const { logging } = action.payload;
      return {
        ...state,
        logging: logging,
      };
    }

    case PROCESS_USER_IN_DB: {
      const { processUserInDb } = action.payload;
      return {
        ...state,
        processUserInDb: processUserInDb,
      };
    }

    case DISPLAY_NAV_BAR: {
      const { displayNavBar } = action.payload;
      return {
        ...state,
        displayNavBar: displayNavBar,
      };
    }

    case DISPLAY_SETTING_BUTTON: {
      const { displaySettingButton } = action.payload;
      return {
        ...state,
        displaySettingButton: displaySettingButton,
      };
    }

    case BRAND: {
      const { brand } = action.payload;
      return {
        ...state,
        brand: brand,
      };
    }

    case ESTABLISHMENT: {
      const { establishment } = action.payload;
      return {
        ...state,
        establishment: establishment,
      };
    }

    case FILTER: {
      const { filter } = action.payload;
      return {
        ...state,
        filter: filter,
      };
    }

    case ORDERS: {
      const { orders } = action.payload;
      return {
        ...state,
        orders: orders,
      };
    }

    case STAFF_WORKS: {
      const { staffWorks } = action.payload;
      return {
        ...state,
        staffWorks: staffWorks,
      };
    }

    case WEATHER_SINGLE_DAY: {
      const { weatherSingleDay } = action.payload;
      return {
        ...state,
        weatherSingleDay: weatherSingleDay,
      };
    }

    case WEATHER_DAYS: {
      const { weatherDays } = action.payload;
      return {
        ...state,
        weatherDays: weatherDays,
      };
    }

    case SUMUPDAYS: {
      const { sumUpDays } = action.payload;
      return {
        ...state,
        sumUpDays: sumUpDays,
      };
    }

    case SINGLESUMUPDAYS: {
      const { singleSumUpDays } = action.payload;
      return {
        ...state,
        singleSumUpDays: singleSumUpDays,
      };
    }

    case CATEGORIES: {
      const { categories } = action.payload;
      return {
        ...state,
        categories: categories,
      };
    }

    case PRODUCTS: {
      const { products } = action.payload;
      return {
        ...state,
        products: products,
      };
    }

    case OPTIONS_LIST: {
      const { optionLists } = action.payload;
      return {
        ...state,
        optionLists: optionLists,
      }
    }

    case STAFFS: {
      const { staffs } = action.payload;
      return {
        ...state,
        staffs: staffs,
      };
    }

    case PAYMENTMODES: {
      const { paymentModes } = action.payload;
      return {
        ...state,
        paymentModes: paymentModes,
      };
    }

    case LOCATIONS: {
      const { locations } = action.payload;
      return {
        ...state,
        locations: locations,
      };
    }

    case ESTABLISHMENTS: {
      const { establishments } = action.payload;
      return {
        ...state,
        establishments: establishments,
      }
    }

    case MERGEDSUMUPDAY: {
      const { mergedSumUpDay } = action.payload;
      return {
        ...state,
        mergedSumUpDay: mergedSumUpDay,
      };
    }

    case MERGEDSUMUPDAYWITHNAMES: {
        const { mergedSumUpDayWithNames } = action.payload;
        return {
            ...state,
            mergedSumUpDayWithNames: mergedSumUpDayWithNames,
        };
    }

    case UPDATE_DB_PROFILE: {
      const { userInDb } = action.payload;
      return {
        ...state,
        userInDb: userInDb,
      };
    }

    case SUPER_ADMIN: {
      const { superAdmin } = action.payload;
      return {
        ...state,
        superAdmin: superAdmin,
      };
    }

    case INITIALIZED: {
      const { isInitialized } = action.payload;
      return {
        ...state,
        isInitialized: isInitialized,
      };
    }

    case AUTHENTICATED: {
      const { isAuthenticated } = action.payload;
      return {
        ...state,
        isAuthenticated: isAuthenticated,
      };
    }

    case E_MAIL_VERIFIED: {
      const { emailVerified } = action.payload;
      return {
        ...state,
        emailVerified: emailVerified,
      };
    }

    default: {
      return { ...state };
    }
  }
};

const AuthContext = createContext({
  ...initialAuthState,
  applyActionCodeContext: () => Promise.resolve(),
  confirmPasswordResetContext: () => Promise.resolve(),
  verifyPasswordResetCodeContext: () => Promise.resolve(),
  sendPasswordResetEmailContext: () => Promise.resolve(),
  createUserWithEmailAndPasswordContext: () => Promise.resolve(),
  signInWithEmailAndPasswordContext: () => Promise.resolve(),
  sendEmailVerificationContext: () => Promise.resolve(),
  signInWithGoogle: () => Promise.resolve(),
  setAuthenticated: () => Promise.resolve(),
  setLogging: () => Promise.resolve(),
  setUploadFileOpen: () => Promise.resolve(),
  setFileUploaded: () => Promise.resolve(),
  setEmailVerified: () => Promise.resolve(),
  setInitialized: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  setContextDbUser: () => Promise.resolve(),
  currentBrand: () => {},
  currentEstablishment: () => {},
  setBrand: () => Promise.resolve(),
  setDisplayNavBar: () => Promise.resolve(),
  setDisplaySettingButton: () => Promise.resolve(),
  toggleProcessUserInDb: () => Promise.resolve(),
  userInRole: () => {},
  //setFilter: () => Promise.resolve(),
  setOrders: () => Promise.resolve(),
  setLoading: () => Promise.resolve(),
});

export const startedPopupDisplayed = "startedPopupDisplayed";
export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  firebase.useDeviceLanguage();
  const [state, dispatch] = useReducer(reducer, initialAuthState);

  const [filter, setFilter] = useState(null);

  const { width, height } = useWindowSize();
  const [ playConfetti, setPlayConfetti ] = useState(false);
  const [ displayGetStartedPopup, setDisplayGetStartedPopup ] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const [itemSource, setItemSource] = useState([]);

  useEffect(() => {

    const loadEstablishments = async () => {

      if (!state?.brand) {
        return;
      }
      const result = await executeQueryUtil(
          getAllEstablishmentsQuery(currentBrand()?.id));

      if (result && result.data && result.data.getEstablishments.length > 0) {
        setEstablishment(result.data.getEstablishments[0]);
      }
    }
    loadEstablishments();

  }, [state.brand])


  useEffect(() => {
    try {
      setLoadingData(true);
      if (!filter || !currentEstablishment()) {
        return;
      }
      const loadData = async () => {
        setLoadingData(true);
        await setLoading(true)
        let result;



        if (filter?.filterType === filterSingleDay && filter?.singleDay) {
          const filterDateString = getFilterDateString(filter?.singleDay);
          const resWeather = await executeQueryUtil(
              getWeatherByDayQuery(currentBrand().id, currentEstablishment()?.id,
                  filterDateString));
          setWeatherSingleDay(resWeather?.data?.getWeatherData || {});

          const resRhDatas = await executeQueryUtil(
              getRhDatasByDayQuery(currentBrand().id, currentEstablishment()?.id,
                  filterDateString));
          setStaffWorks(resRhDatas?.data?.getRhDatas || []);

          result = await executeQueryUtil(
              getOrdersByDayQuery(currentBrand().id, currentEstablishment()?.id,
                  filterDateString));
        } else {
          setOrders([]);
          return;
        }

        if (!result || !result.data) {
          return;
        }
        const ordersRes = result.data.getOrders || result.data.getOrdersByRange;
        let ordersData = [];
        ordersRes.forEach(o => {
          ordersData.push(JSON.parse(o.content));
        })
        setOrders(ordersData);
        await setLoading(false)
      }
      loadData();
    }
    catch (e) {
      console.log(e);
    }
    finally {
      setLoadingData(false);
    }

  }, [filter, state.establishment])


  useEffect(() => {
    try {
      setLoadingData(true);
      if (!currentBrand() || !filter || !currentEstablishment()) {
        return;
      }
      const loadData = async () => {
        await setLoading(true)
        let res = await executeQueryUtil(
            getProductsQuery(currentBrand().id, currentEstablishment()?.id)
        );
        await setProducts(res?.data?.getProducts.map((x) => JSON.parse(x.content)));

        res = await executeQueryUtil(
            getOptionListsQuery(currentBrand().id, currentEstablishment()?.id)
        );
        await setOptionsList(res?.data?.getOptionLists.map((x) => JSON.parse(x.content)));

        res = await executeQueryUtil(
            getCategoriesQuery(currentBrand().id, currentEstablishment()?.id)
        );
        await setCategories(res?.data?.getCategories.map((x) => JSON.parse(x.content)));

        res = await executeQueryUtil(
            getStaffsQuery(currentBrand().id, currentEstablishment()?.id)
        );
        await setStaffs(res?.data?.getStaffs);

        res = await executeQueryUtil(
            getPaymentModesQuery(currentBrand().id, currentEstablishment()?.id)
        );
        setPaymentModes(res?.data?.getPaymentModes);

        res = await executeQueryUtil(
            getLocationsQuery(currentBrand().id, currentEstablishment()?.id)
        );
        setLocations(res?.data?.getLocations);

        res = await executeQueryUtil(
            getAllEstablishmentsQuery(currentBrand().id)
        );
        setEstablishments(res?.data?.getEstablishments);

      }
      loadData();
    }
    catch (e) {
      console.log(e);
    }
    finally {
      setLoadingData(false);
    }

  }, [state.establishment, state.brand])


  async function fillWeatherDays(date, weatherDays) {
    const resWeather = await executeQueryUtil(
        getWeatherByDayQuery(currentBrand().id, currentEstablishment().id,
            date));

    if (resWeather?.data?.getWeatherData) {
      weatherDays.push(resWeather?.data?.getWeatherData);
    }
  }

  async function fillSumupDays(date, sumUpDays, mergedSumUpDay, staffDatas) {
    const resRh = await executeQueryUtil(getRhDatasByDayQuery(currentBrand().id, currentEstablishment().id,
        date))
    let rhDatas
        = resRh?.data?.getRhDatas || [];

    let result = await executeQueryUtil(
        getSumUpDayQuery(currentBrand().id, currentEstablishment().id,
            date));
    if (result && result.data && result.data.getSumUpDay) {
      const contentParsed = JSON.parse(result.data.getSumUpDay.content);

      Object.keys(contentParsed.detailbyStaff || {}).forEach(key => {
        let staff = staffDatas.find(s => s.id === key);
        if (staff && staff.rhId) {
          const rhData = rhDatas.find(rh => rh.id === staff.rhId);
          if (rhData) {
            contentParsed.detailbyStaff[key].totalWorkMinutes = rhData.totalWorkMinutes;
          }
        }
      })

      sumUpDays.push({
        ...result.data.getSumUpDay,
        ...contentParsed,
        dayDate: date,
      });

      if (contentParsed.detailbyStaff) {
        return mergeSumUpDayData(mergedSumUpDay, contentParsed);
      }
      else {
        return mergedSumUpDay;
      }
    }
    else {
      sumUpDays.push({
        dayDate: date,
      });
      return mergedSumUpDay;
    }
  }

  useEffect(() => {
    if (!filter || !currentEstablishment()) return;

    const isDataReady = () =>
        state.staffs?.length > 0 &&
        state.locations?.length > 0 &&
        state.products?.length > 0 &&
        state.categories?.length > 0 &&
        state.optionLists?.length > 0 &&
        state.paymentModes?.length > 0;

    const loadWeeklyData = async (staffDatas) => {
      let mergedSumUpDay = null;
      const sumUpDays = [];
      const weatherDays = [];

      let startDate = moment(filter.singleDay.toISOString()).isoWeekday(1); // start on Monday

      setLoading(true);
      for (let i = 0; i < 7; i++) {
        const date = startDate.clone().add(i, 'days').format('YYYY-MM-DD');
        try {
          await fillWeatherDays(date, weatherDays);

          const resRh = await executeQueryUtil(getRhDatasByDayQuery(currentBrand().id, currentEstablishment().id, date));
          const rhDatas = resRh?.data?.getRhDatas || [];

          const result = await executeQueryUtil(getSumUpDayQuery(currentBrand().id, currentEstablishment().id, date));
          const content = result?.data?.getSumUpDay?.content;
          const parsed = content ? JSON.parse(content) : null;

          if (parsed?.detailbyStaff) {
            Object.keys(parsed.detailbyStaff).forEach(key => {
              const staff = staffDatas.find(s => s.id === key);
              const rhData = staff && rhDatas.find(rh => rh.id === staff.rhId);
              if (rhData) {
                parsed.detailbyStaff[key].totalWorkMinutes = rhData.totalWorkMinutes;
              }
            });

            sumUpDays.push({ ...result.data.getSumUpDay, ...parsed, dayDate: moment(date).format("ll") });
            mergedSumUpDay = mergeSumUpDayData(mergedSumUpDay, parsed);
          } else {
            sumUpDays.push({ dayDate: moment(date).format("ll") });
          }
        } catch (err) {
          console.warn(`Error loading data for ${date}:`, err);
        }
      }

      setMergedSumUpDay(mergedSumUpDay);

      const named = fillDataNames(cloneDeep(mergedSumUpDay), state.staffs, state.locations,
          state.products, state.optionLists, state.paymentModes, state.categories);

      setMergedSumUpDayWithNames(named);
      setSumUpDays(sumUpDays);
      setWeatherDays(weatherDays);
    };

    const loadMonthlyData = async (staffDatas) => {
      const monthStart = moment(filter.singleDay.toISOString()).startOf('month');
      const monthEnd = moment(filter.singleDay.toISOString()).endOf('month');

      setLoading(true);

      console.log('📅 loadMonthlyData - Month:', monthStart.format('MMMM YYYY'));
      console.log('📅 Loading each day from', monthStart.format('YYYY-MM-DD'), 'to', monthEnd.format('YYYY-MM-DD'));

      // Générer la liste de tous les jours du mois
      const allDays = [];
      let current = monthStart.clone();
      while (current.isSameOrBefore(monthEnd)) {
        allDays.push(current.format('YYYY-MM-DD'));
        current.add(1, 'day');
      }

      // Fonction pour charger un jour
      const loadSingleDay = async (dayDate) => {
        const dayDateKey = moment(dayDate).format('ll');
        try {
          const [resRh, result] = await Promise.all([
            executeQueryUtil(getRhDatasByDayQuery(currentBrand().id, currentEstablishment().id, dayDate)),
            executeQueryUtil(getSumUpDayQuery(currentBrand().id, currentEstablishment().id, dayDate))
          ]);

          const rhDatas = resRh?.data?.getRhDatas || [];
          const content = result?.data?.getSumUpDay?.content;
          const parsed = content ? JSON.parse(content) : null;

          if (parsed?.detailbyStaff) {
            Object.keys(parsed.detailbyStaff).forEach(key => {
              const staff = staffDatas.find(s => s.id === key);
              const rhData = staff && rhDatas.find(rh => rh.id === staff.rhId);
              if (rhData) {
                parsed.detailbyStaff[key].totalWorkMinutes = rhData.totalWorkMinutes;
              }
            });

            return {
              ...result.data.getSumUpDay,
              ...parsed,
              date: dayDate,
              dayDate: dayDateKey,
            };
          } else {
            return { date: dayDate, dayDate: dayDateKey, totalTurnover: 0 };
          }
        } catch (err) {
          console.warn(`Error loading day ${dayDate}:`, err);
          return { date: dayDate, dayDate: dayDateKey, totalTurnover: 0 };
        }
      };

      // Charger par batch de 10 jours en parallèle
      const BATCH_SIZE = 20;
      const sumUpDays = [];

      for (let i = 0; i < allDays.length; i += BATCH_SIZE) {
        const batch = allDays.slice(i, i + BATCH_SIZE);
        console.log(`📦 Loading batch ${Math.floor(i / BATCH_SIZE) + 1}/${Math.ceil(allDays.length / BATCH_SIZE)}: ${batch[0]} to ${batch[batch.length - 1]}`);

        const batchResults = await Promise.all(batch.map(loadSingleDay));
        sumUpDays.push(...batchResults);
      }

      // Trier par date pour garantir l'ordre
      sumUpDays.sort((a, b) => a.date.localeCompare(b.date));

      // Merger les données
      let mergedSumUpDay = null;
      sumUpDays.forEach(day => {
        if (day.detailbyStaff) {
          mergedSumUpDay = mergeSumUpDayData(mergedSumUpDay, day);
        }
      });

      setMergedSumUpDay(mergedSumUpDay);

      const named = fillDataNames(cloneDeep(mergedSumUpDay), state.staffs, state.locations,
          state.products, state.optionLists, state.paymentModes, state.categories);

      // DEBUG: Log final sumUpDays
      console.log('📊 FINAL sumUpDays for month:');
      let totalCalculated = 0;
      sumUpDays.forEach((entry, idx) => {
        console.log(`  ${idx}: ${entry.dayDate} => ${entry.totalTurnover?.toFixed(2) || 0} €`);
        totalCalculated += entry.totalTurnover || 0;
      });
      console.log('📊 TOTAL calculated:', totalCalculated.toFixed(2), '€');

      setMergedSumUpDayWithNames(named);
      setSumUpDays(sumUpDays);
      setLoading(false);
    };

    const loadYearlyData = async (staffDatas) => {
      const yearStart = moment(filter.singleDay.toISOString()).startOf('year');
      const yearEnd = moment(filter.singleDay.toISOString()).endOf('year');

      setLoading(true);

      console.log('📅 loadYearlyData - Year:', yearStart.format('YYYY'));

      // Générer la liste de tous les mois de l'année
      const allMonths = [];
      let current = yearStart.clone();
      while (current.isSameOrBefore(yearEnd)) {
        const endOfMonth = current.clone().endOf('month');
        allMonths.push({
          keyDate: current.format('MMMM'),
          monthKey: `${endOfMonth.format('YYYY')}-M${endOfMonth.format('MM')}-${endOfMonth.format('DD-MM')}`,
          monthIndex: current.month()
        });
        current.add(1, 'month');
      }

      // Fonction pour charger un mois
      const loadSingleMonth = async (monthData) => {
        try {
          const result = await executeQueryUtil(getSumUpMonthQuery(
              currentBrand().id,
              currentEstablishment().id,
              monthData.monthKey
          ));

          let content = result?.data?.getSumUpMonth?.content;
          content = content && decompressFromBase64(content);
          const parsed = content ? JSON.parse(content) : null;

          if (parsed?.detailbyStaff) {
            return {
              ...result.data.getSumUpMonth,
              content,
              ...parsed,
              dayDate: monthData.keyDate,
              monthIndex: monthData.monthIndex
            };
          } else {
            return { dayDate: monthData.keyDate, monthIndex: monthData.monthIndex, totalTurnover: 0 };
          }
        } catch (err) {
          console.warn(`Error loading summary for month ${monthData.monthKey}:`, err);
          return { dayDate: monthData.keyDate, monthIndex: monthData.monthIndex, totalTurnover: 0 };
        }
      };

      // Charger tous les 12 mois en parallèle
      console.log('📦 Loading all 12 months in parallel...');
      const sumUpDays = await Promise.all(allMonths.map(loadSingleMonth));

      // Trier par mois pour garantir l'ordre
      sumUpDays.sort((a, b) => a.monthIndex - b.monthIndex);

      // Merger les données
      let mergedSumUpDay = null;
      sumUpDays.forEach(month => {
        if (month.detailbyStaff) {
          mergedSumUpDay = mergeSumUpDayData(mergedSumUpDay, month);
        }
      });

      setMergedSumUpDay(mergedSumUpDay);

      const named = fillDataNames(cloneDeep(mergedSumUpDay), state.staffs, state.locations,
          state.products, state.optionLists, state.paymentModes, state.categories);

      // DEBUG: Log final sumUpDays
      console.log('📊 FINAL sumUpDays for year:');
      let totalCalculated = 0;
      sumUpDays.forEach((entry, idx) => {
        console.log(`  ${idx}: ${entry.dayDate} => ${entry.totalTurnover?.toFixed(2) || 0} €`);
        totalCalculated += entry.totalTurnover || 0;
      });
      console.log('📊 TOTAL calculated:', totalCalculated.toFixed(2), '€');

      setMergedSumUpDayWithNames(named);
      setSumUpDays(sumUpDays);
      setLoading(false);
    };


    const loadDefaultDayData = async (staffDatas) => {
      const date = moment(filter.singleDay.toISOString()).format("YYYY-MM-DD");
      const sumUpDays = [];
      const weatherDays = [];

      await fillWeatherDays(date, weatherDays);
      await fillSumupDays(date, sumUpDays, null, staffDatas);

      if (sumUpDays[0]?.detailbyStaff) {
        const named = fillDataNames(cloneDeep(sumUpDays[0]), state.staffs, state.locations,
            state.products, state.optionLists, state.paymentModes, state.categories);
        setMergedSumUpDay(sumUpDays[0]);
        setMergedSumUpDayWithNames(named);
      } else {
        setMergedSumUpDay(null);
      }

      setSumUpDays(sumUpDays);
      setWeatherDays(weatherDays);
    };

    const loadData = async () => {
      if (!isDataReady()) return;

      setLoadingData(true);

      try {
        const staffRes = await executeQueryUtil(getStaffsQuery(currentBrand().id, currentEstablishment().id));
        const staffDatas = staffRes?.data?.getStaffs || [];

        if (filter?.filterType === filterWeek && filter?.singleDay) {
          await loadWeeklyData(staffDatas);
        } else if (filter?.filterType === filterMonth && filter?.singleDay) {
          await loadMonthlyData(staffDatas)
        } else if (filter?.filterType === filterYear && filter?.singleDay) {
          await loadYearlyData(staffDatas)
        }
        else {
          await loadDefaultDayData(staffDatas);
        }
      } catch (err) {
        console.error("Error in loadData:", err);
      } finally {
        setLoading(false);
        setLoadingData(false);
      }
    };

    loadData();

  }, [filter, state.establishment, state.brand, state.staffs, state.locations]);


  const currentBrand = () => {
    return state.brand;
  }

  const currentEstablishment = () => {
    return state.establishment;
  }

  useEffect(() => {
    let pathName = window.location.pathname;
    //alert(pathName)
    if (pathName.startsWith("/dashboard") &&
        !localStorage.getItem(startedPopupDisplayed)) {
      setDisplayGetStartedPopup(true);
    }
  }, [])

  const setDisplayedGetStartedPopup = () => {
    //localStorage.setItem(startedPopupDisplayed, "true");
    setDisplayGetStartedPopup(false)
  }

  const sendPlayConfetti = () => {
    setPlayConfetti(true);
    setTimeout(() => {
      setPlayConfetti(false)
    }, 5000)
  };

  const signInWithGoogle = () => {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(firebase, provider);
  };

  const createUserWithEmailAndPasswordContext = async (email, password) => {
    return createUserWithEmailAndPassword(firebase, email, password);
  };

  const applyActionCodeContext = async (actionCode) => {
    return applyActionCode(firebase, actionCode);
  };

  const confirmPasswordResetContext = async (actionCode, newPassword) => {
    return confirmPasswordReset(firebase, actionCode, newPassword);
  };

  const verifyPasswordResetCodeContext = async (actionCode) => {
    return verifyPasswordResetCode(firebase, actionCode);
  };

  const sendPasswordResetEmailContext = async (email) => {
    return sendPasswordResetEmail(firebase, email);
  };

  const signInWithEmailAndPasswordContext = async (user, password) => {
    return signInWithEmailAndPassword(firebase, user, password)
  }

  const sendEmailVerificationContext = async () => {
    return sendEmailVerification(firebase.currentUser);
  };


  const updateProfile = async (profileInfo) => {
    var currentUser = await firebase.currentUser;
    if (currentUser) {
      await currentUser.updateProfile(profileInfo);
    }
  };

  const setLoading = async (loading) => {
    dispatch({
      type: LOADING,
      payload: {
        loading: loading,
      }
    });
  };

  const setReloadCustomBoardList = async (reloadCustomBoardList) => {
    dispatch({
      type: RELOAD_CUSTOM_BOARD_LIST,
      payload: {
        reloadCustomBoardList: reloadCustomBoardList,
      }
    });
  }

  const setNavbarMobileReload = async () => {
    dispatch({
      type: NAV_BAR_MOBILE_RELOAD,
      payload: {
        navbarMobileReload: !state.navbarMobileReload,
      }
    });
  }

  const setAuthenticated = async (authenticated) => {
    dispatch({
      type: AUTHENTICATED,
      payload: {
        isAuthenticated: authenticated,
      }
    });
  };

  const setLogging = async (logging) => {
    dispatch({
      type: LOGGING,
      payload: {
        logging: logging,
      }
    });
  };

  const setUploadFileOpen = async (uploadFileOpen) => {
    dispatch({
      type: UPLOAD_FILE_OPEN,
      payload: {
        uploadFileOpen: uploadFileOpen,
      }
    });
  };

  const setFileUploaded = async (fileUploaded) => {
    dispatch({
      type: FILE_UPLOADED,
      payload: {
        fileUploaded: fileUploaded,
      }
    });
  };

  const setEmailVerified = async (emailVerified) => {
    dispatch({
      type: E_MAIL_VERIFIED,
      payload: {
        emailVerified: emailVerified,
      }
    });
  };

  const setInitialized = async (initialized) => {
    dispatch({
      type: INITIALIZED,
      payload: {
        isInitialized: initialized,
      }
    });
  };


  const setBrand = async (brand) => {
    dispatch({
      type: BRAND,
      payload: {
        brand: brand,
      }
    });
  };

  const setEstablishment = async (establishment) => {
    dispatch({
      type: ESTABLISHMENT,
      payload: {
        establishment: establishment,
      }
    });
  }

  // const setFilter = async (filter) => {
  //   dispatch({
  //     type: FILTER,
  //     payload: {
  //       filter: filter,
  //     }
  //   });
  // };

  const setOrders = async (orders) => {
    dispatch({
      type: ORDERS,
      payload: {
        orders: orders,
      }
    });
  };

  const setStaffWorks = async (staffWorks) => {
    dispatch({
      type: STAFF_WORKS,
      payload: {
        staffWorks: staffWorks,
      }
    });
  }

  const setWeatherSingleDay = async (weatherSingleDay) => {
    dispatch({
      type: WEATHER_SINGLE_DAY,
      payload: {
        weatherSingleDay: weatherSingleDay,
      }
    });
  }

  const setWeatherDays = async (weatherDays) => {
    dispatch({
      type: WEATHER_DAYS,
      payload: {
        weatherDays: weatherDays,
      }
    });
  }

  const setProducts = async (products) => {
    dispatch({
      type: PRODUCTS,
      payload: {
        products: products,
      }
    });
  };

  const setOptionsList = async (optionLists) => {
    dispatch({
      type: OPTIONS_LIST,
      payload: {
        optionLists: optionLists,
      }
    })
  }

  const setCategories = async (categories) => {
    dispatch({
      type: CATEGORIES,
      payload: {
        categories: categories,
      }
    });
  };

  const setStaffs = async (staffs) => {
    dispatch({
      type: STAFFS,
      payload: {
        staffs: staffs,
      }
    });
  };

  const setPaymentModes = async (paymentModes) => {
    dispatch({
      type: PAYMENTMODES,
      payload: {
        paymentModes: paymentModes,
      }
    });
  };

  const setLocations = async (locations) => {
    dispatch({
      type: LOCATIONS,
      payload: {
        locations: locations,
      }
    });
  };

  const setEstablishments = async (establishments) => {
    dispatch({
      type: ESTABLISHMENTS,
      payload: {
        establishments: establishments,
      }
    });
  }

  const setSumUpDays = async (sumUpDays) => {
    dispatch({
      type: SUMUPDAYS,
      payload: {
        sumUpDays: sumUpDays,
      }
    });
  };

  const setSingleSumUpDays = async (singleSumUpDays) => {
    dispatch({
      type: SINGLESUMUPDAYS,
      payload: {
        singleSumUpDays: singleSumUpDays,
      }
    });
  }

  const setMergedSumUpDay = async (mergedSumUpDay) => {
    dispatch({
      type: MERGEDSUMUPDAY,
      payload: {
        mergedSumUpDay: mergedSumUpDay,
      }
    });
  };

    const setMergedSumUpDayWithNames = async (mergedSumUpDayWithNames) => {
        dispatch({
            type: MERGEDSUMUPDAYWITHNAMES,
            payload: {
                mergedSumUpDayWithNames: mergedSumUpDayWithNames,
            }
        });
    }


  const setDisplayNavBar = async (displayNavBar) => {
    dispatch({
      type: DISPLAY_NAV_BAR,
      payload: {
        displayNavBar: displayNavBar,
      }
    });
  };

  const setDisplaySettingButton = async (displaySettingButton) => {
    dispatch({
      type: DISPLAY_SETTING_BUTTON,
      payload: {
        displaySettingButton: displaySettingButton,
      }
    });
  };

  const toggleProcessUserInDb = async () => {
    dispatch({
      type: PROCESS_USER_IN_DB,
      payload: {
        processUserInDb: !state.processUserInDb,
      }
    });
  };

  const userInRole = (role) => {
    return (state.userInDb?.roles || []).includes(role);
  }

  const currentUser = () => {
    var user = firebase.currentUser;
    return user;
  };


  function setContextDbUser(userInDb) {
    dispatch({
      type: UPDATE_DB_PROFILE,
      payload: {
        userInDb: userInDb,
      }
    });
  }

  function setUserSuperAdmin(value) {
    dispatch({
      type: SUPER_ADMIN,
      payload: {
        superAdmin: value,
      }
    });
  }



  const logout = async () => {
    await setContextDbUser(null);
    return firebase.signOut();
  };


  async function processUserInDb(user) {
    const resSuperAdmins = await executeQueryUtil(getSuperUserWhiteListQuery())
    const allSuperAdminEmails = (resSuperAdmins?.data?.getSuperUsers || []).map(item => item.email);
    let isSuperAdmin = allSuperAdminEmails.includes(user.email);
    setUserSuperAdmin(isSuperAdmin);
    //alert("user.uid " + user.uid)
    const res = await executeQueryUtil(getProductUserQuery(user.uid));
    setContextDbUser(res?.data?.getProductUser);
    let userDb = res?.data?.getProductUser;
    //alert("userDb " + JSON.stringify(userDb || {}))
    if (!userDb && user.email.endsWith("gmail.com")) {
      window.location.reload();
    }
    if (userDb) {
      let resUser = await executeQueryUtil(getTempBrandUserByEmailQuery(user.email));
      let tempBrandUser = resUser?.data?.getTempBrandUserByEmail;
      if (tempBrandUser && tempBrandUser.id && user.emailVerified) {
        let userDbClone = cloneDeep(userDb)
        if (!userDb.brandId) {
          userDbClone.brandId = tempBrandUser.brandId;
          userDbClone.mainUser = false;
          let resUpdateUser = await executeMutationUtil(updateProductUserMutation(userDbClone));
          userDb = resUpdateUser.data.updateProductUser;
        }
        if (!(userDbClone?.allowedBrandIds || []).includes(tempBrandUser.brandId)) {
          if (!userDbClone.allowedBrandIds) {
            userDbClone.allowedBrandIds = [];
          }
          userDbClone.allowedBrandIds.push(tempBrandUser.brandId);
          let resUpdateUser = await executeMutationUtil(updateProductUserMutation(userDbClone));
          userDb = resUpdateUser.data.updateProductUser;
        }
        await executeMutationUtil(bulkDeleteTempBrandUserMutation([tempBrandUser.id]));
        setContextDbUser(userDbClone);
      }
      if (userDb.brandId) {

        let resBrand;
        // if (isSuperAdmin) {
        //   resBrand = await executeQueryUtil(getBrandAdminQuery(userDb.brandId));
        //   await setBrand(resBrand?.data?.getBrandAdmin);
        //   if (!isPathAllowedNotLogged(window.location.pathname)) {
        //     navigate('/dashboard', { replace: true });
        //   }
        //
        // }
        // else {
        resBrand = await executeQueryUtil(getBrandQuery(userDb.brandId));
        //alert("resBrand " + JSON.stringify(resBrand?.data?.getBrand))
        await setBrand(resBrand?.data?.getBrand);
        // if (!isPathAllowedNotLogged(window.location.pathname)) {
        //   navigate('/dashboard', { replace: true });
        // }
        // }
      }
    }
  }

  useEffect(() => {
    if (currentUser()) {
      processUserInDb(currentUser())
    }
  }, [state.processUserInDb])


  useEffect(() => {
    const loadFilterDefault = async () => {
      if (!filter?.filterType) {
        setFilter({
          ...filter,
          filterType: filterSingleDay,
        })
      }
      if (!filter?.singleDay && currentEstablishment()) {
        let result =
            await executeQueryUtil(getDaysQuery(currentBrand().id, currentEstablishment().id));
        const days = cloneDeep(result.data.getDays);
        days.sort((a, b) => {
          return b.dayDate.toString().localeCompare(a.dayDate.toString());
        });
        if (days && days.length > 0) {
          await setFilter({
            ...filter,
            singleDay: dayjs(days[0].dayDate)
          })
        }
      }
    }
    loadFilterDefault();
  }, [filter, currentEstablishment(), currentBrand()]);

  useEffect(() => {
    const unsubscribe = firebase.onAuthStateChanged(async (user) => {
      if (user) {
        if (!firebase.currentUser) {
          return
        }
        try {
          let token = await firebase.currentUser.getIdToken(true)
          localStorage.setItem("authToken", token)
          localStorage.setItem("genTimeToken", moment().unix())
        }
        catch (err) {
          console.log(err);
        }

        await processUserInDb(user);

        setAuthenticated(true);
        setEmailVerified(user.emailVerified)
      } else {
        localStorage.removeItem("authToken")
        setAuthenticated(false)
      }

      setInitialized(true)
    });

    return unsubscribe;
  }, [dispatch]);

  function isPathAllowedNotLogged(pathname) {
    if (pathname.startsWith('/displayEvents')) {
      return true;
    }

    return [
      "/" + authChangeRoute,
      "/" + authChangeRoute,
      "/" + resetPasswordRoute,
      "/" + loginRoute,
      // "/" + connectScreen,
      "/" + emailVerificationRoute,
      "/" + customChartRoute,
      "/" + registerRoute,
      "/401"
      // "/app/" + accountRoute,
      //"/" + graphQlRoute,
      // "/" + displayEventsFoundRoute,
      // "/" + displayEventsFoundRoute,
      // "/screenDisplay",
    ].find(p => {
      return pathname.startsWith(p)
    }) != null
  }

  if (!state.isInitialized) {
    return <SplashScreen />;
  }

  if ((!state.isAuthenticated || !state.emailVerified) && !isPathAllowedNotLogged(window.location.pathname)) {
    return <Navigate to={"/login"}/>
  }




  return (
      <AuthContext.Provider
          value={{
            ...state,
            filter,
            setReloadCustomBoardList,
            signInWithGoogle,
            verifyPasswordResetCodeContext,
            confirmPasswordResetContext,
            sendPasswordResetEmailContext,
            createUserWithEmailAndPasswordContext,
            signInWithEmailAndPasswordContext,
            sendEmailVerificationContext,
            applyActionCodeContext,
            logout,
            currentUser,
            updateProfile,
            setAuthenticated,
            setLogging,
            setEmailVerified,
            setInitialized,
            setContextDbUser,
            currentBrand,
            currentEstablishment,
            setBrand,
            setEstablishment,
            userInRole,
            setDisplayNavBar,
            setDisplaySettingButton,
            toggleProcessUserInDb,
            setFileUploaded,
            setUploadFileOpen,
            sendPlayConfetti,
            setFilter,
            setOrders,
            setSumUpDays,
            loadingData,
            setLoading,
            setNavbarMobileReload,
          }}
      >


        {currentBrand() &&
            <FileUploader
                brandId={currentBrand().id}
                onClose={() => {
                  alert("onClose");
                  setUploadFileOpen(false);
                }}
                open={true}
                onUpload={(files) => {
                  setFileUploaded(!state.fileUploaded)
                }}
            />
        }
        {children}

        {/*<p>{JSON.stringify(state)}</p>*/}

        {playConfetti &&
            <Confetti
                width={width}
                height={height}
            />
        }
      </AuthContext.Provider>
  );
};

export default AuthContext;
